import { Box, SxProps } from '@mui/material';
import React, { useEffect, useState } from 'react';

interface Gap {
    width?: number | string;
    height?: number | string;
}

interface CustomListProps {
    list: Array<any>;
    gap?: Gap;
    disableWrap?: boolean;
    styles?: SxProps;
    elementInImage?: any;
}

const CustomList: React.FC<CustomListProps> = ({ list, gap, disableWrap, styles, elementInImage }) => {
    const [dimentions, setDimentions] = useState<Gap>({ width: 0, height: 0 });

    useEffect(() => setDimentions((prev) => gap || prev), [gap]);

    return (
        <Box
            sx={{
                display: 'flex',
                flexWrap: disableWrap ? 'unset' : 'wrap',
                overflow: disableWrap ? 'auto' : null,
                rowGap: dimentions.height,
                columnGap: dimentions.width,
                ...styles,
            }}
        >
            {list}{' '}
            {elementInImage ? (
                <Box sx={{ position: 'relative', bottom: 63, left: 8, width: 'calc(100% - 16px)' }}>
                    {elementInImage}
                </Box>
            ) : null}
        </Box>
    );
};

export default CustomList;
